import { render } from "./IntegracaoLocaWeb.vue?vue&type=template&id=4a5467a8&ts=true"
import script from "./IntegracaoLocaWeb.vue?vue&type=script&lang=ts"
export * from "./IntegracaoLocaWeb.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__